<template>
    <div class="w100 Contenido oHidden">
        <ModalNuevoProductor v-show="ModalVisible" @Cerrar="CerrarModal" />

        <div class="TituloSeccion">
            <font-awesome-icon
                icon="users"
                size="4x"
                :style="{ color: 'black' }"
                class="IconoTituloSeccion fLeft"
            />
            <div class="fLeft">Productores</div>

            <!-- <div class="fRight mR5 BotonAgregar" @click="VerModal()">
        <font-awesome-icon  icon="plus" size="4x" :style="{ color: '#FFF'}"  class="IconoBoton"/>
        +
      </div> -->
            <div class="clear"></div>
        </div>

        <div class="table-wrapper">
            <table class="fl-table">
                <thead>
                    <tr>
                        <th class="c1">Nombre</th>
                        <th class="c2">Localidad</th>
                        <th class="c3">Telefono</th>
                        <th class="c3">Vendedor</th>
                        <th class="pR c4">
                            <font-awesome-icon
                                v-on:click.stop="VerModal()"
                                icon="plus-circle"
                                size="4x"
                                :style="{ color: '#005625' }"
                                class="IconoAgregar Centro"
                            />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="p in Productores"
                        :key="p._Id"
                        @click="VerEstablecimientos(p._Id)"
                    >
                        <td class="c1">{{ p._Apellido }}, {{ p._Nombre }}</td>
                        <td class="c2">{{ p._Localidad }}</td>
                        <td class="c3">{{ p._Telefono }}</td>
                        <td class="c3">{{ p._Vendedor }}</td>
                        <td class="c4">
                            <font-awesome-icon
                                v-on:click.stop="
                                    EliminarProductor(
                                        p._Id,
                                        p._Nombre + ' ' + p._Apellido
                                    )
                                "
                                icon="trash-alt"
                                size="4x"
                                :style="{ color: '#934141' }"
                                class="h100 IconoEliminar"
                            />
                        </td>
                    </tr>
                </tbody>
                <tbody></tbody>
            </table>

            <Loader :visible="showLoader" />
        </div>

        <SlidingPagination
            v-show="totalPages > 1"
            :slidingEndingSize="2"
            :slidingWindowSize="2"
            :current="currentPage"
            :total="totalPages"
            @page-change="CambioDePagina"
        ></SlidingPagination>
    </div>
</template>

<script>
import axios from "axios";
import ModalNuevoProductor from "../../components/Utilidades/ModalNuevoProductor";
import SlidingPagination from "vue-sliding-pagination";

export default {
    name: "Productores",
    data() {
        return {
            showLoader: false,
            Productores: null,
            ProductoresFull: null,
            _UserOk: false,
            Error: null,
            ModalVisible: false,
            currentPage: 0,
            totalPages: 0,
            ItemsPorPagina: 10,
            RecalcularPaginado() {
                this.Productores = [];
                this.totalPages = Math.ceil(
                    this.ProductoresFull.length / this.ItemsPorPagina
                );
                for (let i = 0; i < this.ProductoresFull.length; i++) {
                    if (i >= (this.currentPage - 1) * this.ItemsPorPagina) {
                        if (i < this.currentPage * this.ItemsPorPagina) {
                            this.Productores.push(this.ProductoresFull[i]);
                        }
                    }
                }
            },
        };
    },
    mounted() {
        this._UserOk = this.$parent.Datos.ChequearSesionUsuario(this.$router);
        if (this._UserOk) {
            if (this.$parent.Datos.AdminLogueado()) {
                this.ObtenerDatos();
            } else {
                this.$router.push("/");
            }
            //this.ObtenerDatos();
        } else {
            this.$router.push("/");
        }
    },
    methods: {
        ObtenerDatos() {
            var _This = this;
            var _User = _This.$parent.Datos._User;
            axios
                .post(_This.urlPosts + "/AgroIdeas/Productores", {
                    IdUsuario: _User._ID,
                })
                .then(function (response) {
                    _This.showLoader = false;
                    _This.ProductoresFull = response.data;
                    _This.currentPage = 1;
                    _This.RecalcularPaginado();
                })
                .catch(function (error) {
                    _This.showLoader = true;
                    _This.Error = error;
                })
                .then(function () {});
        },
        ClickNuevo() {
            this.$notify({
                group: "Notificaciones",
                title: "Productor agregado!", //Puede ser HTML
                type: "success",
                speed: 500,
                duration: 3000,
                // text: 'Hello user! This is a notification!'//Puede ser HTML
            });
            //this.VerModal();
        },
        VerModal() {
            this.ModalVisible = true;
        },
        CerrarModal() {
            this.ModalVisible = false;
        },
        EliminarProductor(_Id, _Nombre) {
            var _This = this;
            //alert(_Nombre);
            this.$confirm({
                title: "ATENCIÓN",
                message: "Estás seguro de eliminar a " + _Nombre + "?",
                button: {
                    yes: "Si",
                    no: "No",
                },
                callback: (confirm) => {
                    if (confirm) {
                        axios
                            .post(
                                _This.urlPosts + "/AgroIdeas/EliminarProductor",
                                {
                                    IdUsuario: _This.$parent.Datos._User._ID,
                                    IdProductor: _Id,
                                }
                            )
                            .then(function (response) {
                                _This.$parent.Notificacion(
                                    "Productor eliminado!",
                                    "",
                                    "success",
                                    3
                                );
                                _This.ObtenerDatos();
                            })
                            .catch(function (error) {
                                _This.$parent.Notificacion(
                                    "Error!",
                                    "",
                                    "error",
                                    3
                                );
                                console.error(error);
                            })
                            .then(function () {
                                //console.log("Ok");//LLega siempre que no haya catch
                            });
                    }
                },
            });
        },
        VerEstablecimientos(_Id) {
            this.$router.push("/establecimientos/" + _Id);
        },
        CambioDePagina(selectedPage) {
            this.currentPage = selectedPage;
            this.RecalcularPaginado();
        },
    },
    components: {
        ModalNuevoProductor,
        SlidingPagination,
    },
};
</script>

<style lang="scss" scoped>
@import "../../Css/Componentes.scss";
@import "~vue-sliding-pagination/dist/style/vue-sliding-pagination.css";
// .c1{min-width:100px;}
// .c2{min-width:100px;}
// .c1{width:40%;}
// .c2{width:40%;}
// .c3{width:20%;}
// .c4{max-width:20px;}
.IconoEliminar {
    width: 20px;
    padding: 0 5px;
}
</style>
